import authStore from "./stores/authStore";
import consts from './consts';
import jsonwebtoken from 'jsonwebtoken';
import moment from 'moment';

class Http {
  jwt;
  refreshing=false;

  clear() {
    this.jwt = null;
  }

  crequest(url, options) {
    const company = authStore.currentCompany;
    const companySlug = `contracts/${company.contractid}/companies/${company.COMPANYID}/`;
    return this.request(companySlug + url, options);
  }

  
  request(url, _options) {
    const options = _options || {};

    if (options.json) {
      options.body = JSON.stringify(options.json);
    }

    if (!options.headers) {
      options.headers = {
        'Content-Type': 'application/json'
      };
    }

    if (this.jwt) {
      options.headers.Authorization = 'Bearer ' + this.jwt;
    }

    // If token refresing is on process, wait 100ms for continue
    if(this.refreshing){  
      this.sleep(100);
    }
      
    return this.fetch_retry(consts.API + url, options, true);
 
  }

  refreshRequest = async (_options) => {
    const options = _options || {};
    let isExpiring = this.checkIsExpiring();
    
    if (!options.headers) {
      options.headers = {
        'Content-Type': 'application/json'
      };
    }

    if (this.jwt) {
      options.headers.Authorization = 'Bearer ' + this.jwt;
    }

    // expiring
    if(isExpiring === 1){
      if(!this.refreshing){
        this.refreshing=true;
        setTimeout(() => {  this.refreshing = false }, 100);
        let newToken = await this.fetch_retry(consts.API + 'refresh', options, true);
        if ( newToken["token"] ){     
          authStore.setJWT(newToken["token"]);
          this.refreshing = false; 
          return true;     
        }
      }
    }
    
    //expired
    if(isExpiring === -1){
      return this.fetch_retry(consts.API + 'check', options, true);
    }

    // not expiring
    return false;
  }


  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  checkIsExpiring(){   
    if(this.jwt){
      try{
        var decodedJWT = jsonwebtoken.decode(this.jwt);
        let now = moment().utc().valueOf() / 1000;
        let nowPlusWeek = moment().utc().add(1, 'weeks').valueOf() / 1000;

        if (decodedJWT.exp < now) {
          // expired
          return -1;
        }
        if ( decodedJWT.exp < nowPlusWeek) {
          // expiring
          return 1;
        }
        // not expiring
        return 0;    
      }
      catch(error){      
        return -1;
      }
    }
    // expired for default
    return -1;
  }

  fetch_retry(url, options, initial_fetch){
    return fetch(url, options)
    .then(response => {
      
    return response.json()
    .then((json) => {
      
      if(response.status !== 200){
        if ( ( json["error"] === "token_expired"  || json["error"] === "token_blacklisted"  ) && response.status === 400) {
          
          if(initial_fetch){
            // only single repeat allowed
            initial_fetch = false;
            
            if ( json["error"] === "token_expired" && json["new_token"] ){     
                authStore.setJWT(json["new_token"]);     
            }
            // set new token
            options.headers.Authorization = 'Bearer ' + this.jwt;
            
            // make new call
            return this.fetch_retry(url, options, initial_fetch);

          }else{
            // retry made but didn't solve authentication
            authStore.logout();
          }
        }
        if (json["error"] === "token_not_valid" && response.status === 400) {
          // Log user out is token has expired         
          authStore.logout();
        }

        if (json["error"] === "token_not_valid_pw_changed" && response.status === 400) {
          // Log user out is token invalid because password changed
          authStore.logout();
        }
        //unsuccessfull
        return Promise.reject({
          data: json,
          status: response.status
        });

      }
      // successfull    
      return json;
    })
    }).catch((error) => {
      return Promise.reject({
        data: error.data,
        status: error.status
      });
    });

  }

  setJWT(jwt) {
    this.jwt = jwt;
  }
}

export default new Http();
